export const AddRecipientFrom = {
    Bank: 'bank',
    ManageRecipient: 'manageRecipient',
    SendPayment: 'sendPayment'
};

export const currencyCodes = {
    gbp: 'GBP',
    eur: 'EUR',
    clp: 'CLP'
};

export const countryCodes = {
    uk: 'GB',
    chile: 'CL',
};



